import { Component, HostBinding, OnDestroy, OnInit } from '@angular/core';
import { Alert, ALERT_TYPE } from '../../../../../../components/alert/alert.model';
import { ProductChangesComponent } from './product-changes/product-changes.component';
import { Observable, Subscription } from 'rxjs';
import { ProductAllowedQuantityService } from './core/product-allowed-quantity.service';
import { ProductAllowedQuantityRequest } from '../../../_core/quantiProduct.model';
import { CustomActiveCartService } from '../../../_core/active-cart.service';
import { TranslationService } from '@spartacus/core';

@Component({
  selector: 'product-allowed-quantity',
  templateUrl: './product-allowed-quantity.component.html',
  styleUrl: './product-allowed-quantity.component.scss',
  standalone: false,
})
export class ProductAllowedQuantityComponent implements OnInit, OnDestroy {
  @HostBinding('class.d-none') hideClass = true;

  request$: Observable<ProductAllowedQuantityRequest> = this.productAllowedQuantityService.request$;

  alert: Alert = {
    isActive: true,
    content: '',
    component: ProductChangesComponent,
    hasCloseButton: false,
    type: ALERT_TYPE.WARNING,
  };

  subscription = new Subscription();
  showMessage = false;

  constructor(
    private productAllowedQuantityService: ProductAllowedQuantityService,
    private activeCart: CustomActiveCartService,
    private translationService: TranslationService,
  ) {}

  ngOnInit(): void {
    this.checkCart();
    this.checkRequest();
    this.setAlertContent();
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }

  checkRequest() {
    this.subscription.add(
      this.request$.subscribe(request => {
        this.showMessage = (request?.productChanges || []).length > 0;
        this.hideClass = !this.showMessage;
      }),
    );
  }

  checkCart() {
    this.subscription.add(
      this.activeCart.getEntries().subscribe(entries => {
        this.alert.isActive = entries.length > 0;

        if (entries.length === 0) {
          this.productAllowedQuantityService.request$.next({});
        }
      }),
    );
  }

  setAlertContent() {
    this.translationService
      .translate('productQuantityAllowed.invalidQuantitiesAlert')
      .subscribe((translation: string) => {
        this.alert.content = translation;
      });
  }
}
